import { z } from 'zod';
import { activityKindSchema } from './content.js';
/**
 * Mio, the learner's private mentor. These contracts are shared by the web client and the
 * mentor backend so the frontend can be built ahead of it.
 */
export const mioRoleSchema = z.enum(['learner', 'mio']);
export const mioMessageSchema = z.object({
    id: z.string(),
    role: mioRoleSchema,
    content: z.string(),
    createdAt: z.iso.datetime(),
});
/** What Mio can see about where the learner is right now. Derived client-side from the cached program and the route. */
export const mioContextSchema = z.object({
    route: z.string(),
    environment: z.enum(['home', 'program', 'studio', 'workshop', 'field', 'other']),
    currentModule: z.number().int(),
    totalModules: z.number().int(),
    completionPercent: z.number(),
    completedCount: z.number().int(),
    activityCount: z.number().int(),
    module: z
        .object({ number: z.number().int(), title: z.string(), mioStance: z.string() })
        .nullable(),
    activity: z
        .object({
        id: z.string(),
        code: z.string(),
        kind: activityKindSchema,
        title: z.string(),
        status: z.enum(['not_started', 'in_progress', 'complete']),
    })
        .nullable(),
    nextActivity: z
        .object({ id: z.string(), code: z.string(), kind: activityKindSchema, title: z.string() })
        .nullable(),
    /** Destination and visible activity may differ while the old IDE is being saved. */
    workshopTransition: z
        .object({
        requestedActivityId: z.string(),
        state: z.enum(['pending', 'preview']),
    })
        .optional(),
});
export const mioReplyRequestSchema = z.object({
    messages: z.array(mioMessageSchema).max(50),
    context: mioContextSchema,
});
export const mioReplyResponseSchema = z.object({
    message: mioMessageSchema,
    /** Optional follow-ups Mio suggests the learner might ask next. */
    suggestions: z.array(z.string()).default([]),
});
